//
// Logo Carousel Functions
//
import { Carousel } from "@fancyapps/ui";
import { Autoplay } from "@fancyapps/ui/dist/carousel/carousel.autoplay.esm.js";

export default class LogoCarousel {
  constructor() {

    this.logoCarousels = document.querySelectorAll('.js-client-logo-carousel');

    const options = {
      transition: "slide",
      slidesPerPage: 1,
      Navigation: false,
      Autoplay: {
        timeout: 1000,
        showProgress: false,
      },
    };

    this.logoCarousels.forEach(logoCarousel => {
      new Carousel(logoCarousel, options, { Autoplay });
    });

  }
}